import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import immutableToJS from 'utils/immutableToJS';

import {
  currentCaseSelector,
} from 'redux/cases/selectors';

/* istanbul ignore next */
const withConnectedData = (WrappedComponent) => {
  function Container(props) {
    return (
      <WrappedComponent {...props} />
    );
  }

  Container.propTypes = {
    info: PropTypes.shape({
      complaint: PropTypes.shape({
        code: PropTypes.string,
        description: PropTypes.string,
      }),
      description: PropTypes.string,
    }).isRequired,
  };

  Container.defaultProps = {
    caseInfo: {},
  };

  function mapStateToProps(state) {
    return {
      info: currentCaseSelector(state),
    };
  }

  return connect(mapStateToProps)(immutableToJS(Container));
};

export default withConnectedData;



// WEBPACK FOOTER //
// ./compositions/ComplaintWidget/CaseComplaintContainer.js